import { Space } from 'antd';
import { useSession } from '../contexts/SessionContext';
import { useWebContainer } from '../contexts/WebContainerContext';

interface GalleryProps {
  routers: string[];
  style?: React.CSSProperties;
  className?: string;

  width?: number;
  height?: number;
  scale?: number;
}

const Gallery: React.FC<GalleryProps> = ({ routers, style, className, width = 1440, height = 1024, scale = 0.5 }) => {
  const { loading } = useSession();
  const { iframeSrc } = useWebContainer();

  const transformed = {
    width: width * scale,
    height: height * scale,
  };
  const size = {
    width,
    height,
  };

  if (loading || !iframeSrc) {
    return null;
  }

  return (
    <div className={className} style={{ position: 'relative', ...style }}>
      <Space wrap size={'large'}>
        {routers.map(router => (
          <div key={router} style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '5px', margin: '10px' }}>
            {router}
            <div style={{ ...transformed }}>
              <iframe
                src={`${iframeSrc}/${router}`}
                style={{ ...size, transform: `scale(${scale})`, transformOrigin: '0 0' }}
              />
            </div>
          </div>
        ))}
      </Space>
    </div>
  );
};

export default Gallery;
